import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { MdSearch } from 'react-icons/md';
import {
    Input,
    InputGroup,
    InputGroupText,
    Modal,
    ModalBody,
    ModalHeader,
} from 'reactstrap';

import SearchAgentClients from './SearchAgentClients';
import SearchLawyerContacts from './SearchLawyerContacts';
import SearchLeads from './SearchLeads';
import SearchMatters from './SearchMatters';
import SearchReferrals from './SearchReferrals';

import { getAuth } from '../../../redux/selectors';
import isInRole from '../../../utility/helpers/isInRole';
import SearchAttorneys from './SearchAttorneys';

const GlobalSearch = () => {
    const { loggedUser } = useSelector(getAuth);

    const [searchCriteria, setSearchCriteria] = useState('');
    const [searchParams, setSearchParams] = useState({
        searchCriteria: '',
    });

    const handleSearch = async (searchCriteria) => {
        setModal(!!searchCriteria);
        setSearchParams({ searchCriteria: searchCriteria });
    };
    const [modal, setModal] = useState(false);

    useEffect(() => {
        if (modal) {
            document.body.classList.add('overflow-hidden');
        } else {
            document.body.classList.remove('overflow-hidden');
        }
    }, [modal]);

    const toggle = () => setModal(!modal);

    return (
        <div className="global-search">
            <InputGroup className="search-input-group">
                <InputGroupText
                    onClick={() => {
                        handleSearch(searchCriteria);
                    }}
                >
                    <MdSearch size={24} color="#333333" />
                </InputGroupText>
                <Input
                    className="search-input"
                    name="searchCriteria"
                    placeholder="Search Qase"
                    value={searchCriteria}
                    onChange={(e) => {
                        setSearchCriteria(e.target.value);
                    }}
                    onKeyPress={(e) => {
                        if (e.key === 'Enter') {
                            handleSearch(searchCriteria);
                        }
                    }}
                />
            </InputGroup>

            <Modal
                isOpen={modal}
                toggle={toggle}
                backdrop={false}
                fullscreen
                modalClassName="global-search-modal"
            >
                <ModalHeader toggle={toggle}>
                    {`Search Results for “${searchParams.searchCriteria}”`}
                </ModalHeader>
                <ModalBody>
                    <SearchReferrals
                        searchCriteria={searchParams.searchCriteria}
                        toggleModal={toggle}
                    />

                    <SearchLeads
                        searchCriteria={searchParams.searchCriteria}
                        toggleModal={toggle}
                    />

                    <SearchMatters
                        searchCriteria={searchParams.searchCriteria}
                    />

                    {isInRole(loggedUser.roles, 'lawyer') ? (
                        <SearchLawyerContacts
                            searchCriteria={searchParams.searchCriteria}
                        />
                    ) : (
                        <SearchAgentClients
                            searchCriteria={searchParams.searchCriteria}
                        />
                    )}

                    {isInRole(loggedUser.roles, 'agent') ? (
                        <SearchAttorneys
                            searchCriteria={searchParams.searchCriteria}
                        />
                    ) : null}
                </ModalBody>
            </Modal>
        </div>
    );
};

export default GlobalSearch;
